import { Component, OnInit } from '@angular/core';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { StatusBtnCellrender } from 'src/app/core/grid-renderer/status.grid-render';
import { EventService } from 'src/app/services/event.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from '../../core/constant/common.constant';
import { HistoryDetailService } from 'src/app/services/history-detail.service';
import { Constants } from 'src/app/constants';
import { DatePipe } from '@angular/common';
import { AetStateService } from 'src/app/services/aet-state.service';
import moment from 'moment';
import { FilterChangedEvent, GridOptions } from 'ag-grid-community';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-event',
    templateUrl: './event.component.html',
    styleUrls: ['./event.component.scss'],
    standalone: false // NOSONAR
})

export class EventComponent implements OnInit {

  faChevronRight = faChevronRight;
  gridApi: any;
  rowHeight = 30;
  defaultColDef: {};
  columnDefs: any[] = [];
  paginationPageSize: number = 10;
  icons: {};
  rowClassRules: any;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  totalPage: number = 0;
  displayRowData: any[] = [];
  currentPageForTotalPage!: number;
  isLastPageFound!: boolean;
  rowCount: number = 0;
  historyRowData: any;
  rowData: any;
  gridOptions: any;
  name: any;
  eventData: any;
  problemType: string;
  eventStatus: string;
  logisticProvider: string;
  eventComments: string;
  lastUpdated: string;
  lastUpdatedBy: string;
  eventId: string;
  errorMessage: any;
  successMessage: any;
  reOpen: boolean = false;
  eventType: any;
  plannedUnload: string;
  eventRegion: string;
  eventRoute: string;
  eventEta: string;
  isAccessible=true;
  constructor(public readonly history: HistoryDetailService,
      private readonly dialog : MatDialog,
     private readonly eventService : EventService,
     private readonly route : ActivatedRoute,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
    public constants: Constants, private readonly aetStateService : AetStateService,
     private readonly router: Router) {
    this.defaultColDef = {
      suppressPaginationPanel: true,
      autoHeight: true,
      filter: true,
      floatingFilter: true
    }

    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">'
    };

    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0',  // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0', // NOSONAR
    };
  }

  ngOnInit(): void {
    // this.checkRoles();
    this.eventType = '';
    this.plannedUnload = '';
    this.eventRegion = '';
    this.eventRoute = '';
    this.eventEta = '';
    this.problemType = '';
    this.plannedUnload = '';
    this.eventStatus = '';
    this.logisticProvider = '';
    this.eventComments = '';
    this.lastUpdated = '';
    this.lastUpdatedBy = '';
    this.eventId = '';
    this.reOpen = false;
    if(localStorage.getItem('eventId')) {
      this.eventId = localStorage.getItem('eventId');
    }
    this.loadEventData();
     
    this.columnDefs = [{
      headerName: "PLANT", field: "plantId",
      sortable: true, unSortIcon: true, floatingFilter: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      filter: 'agTextColumnFilter',
      minWidth: 150,
      //maxWidth: 190,
    },
    {
      headerName: "NOT ASSIGNED", field: "notAssigned",
      sortable: true, unSortIcon: true,  floatingFilter: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      filter: 'agTextColumnFilter',
      minWidth: 150, 
      //maxWidth: 190,
    },
    {
      headerName: "EXPEDITES", field: "expedites",
      sortable: true, unSortIcon: true,
      floatingFilter: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      filter: 'agTextColumnFilter',
      minWidth: 150, 
      //maxWidth: 190,
    },
    {
      headerName: "PULL-AHEADS", field: "pullAheads",
      sortable: true, unSortIcon: true,
      floatingFilter: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      filter: 'agTextColumnFilter',
      minWidth: 150,  
      //maxWidth: 180,
    },
    {
      headerName: "TAIL-LOADS", field: "tailLoads",
      sortable: true, unSortIcon: true,
      floatingFilter: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      filter: 'agTextColumnFilter',
      minWidth: 150,
      //maxWidth: 180,
    },
    {
      headerName: "OTHERS", field: "others",
      sortable: true, unSortIcon: true,
      floatingFilter: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      filter: 'agTextColumnFilter',
      minWidth: 150,
      //maxWidth: 180,
    },
    {
      headerName: "STATUS", field: "statusId",
      cellRenderer: StatusBtnCellrender,
      minWidth: 150,
      //maxWidth: 180,
    },]

  }
  async checkRoles() {
    await this.aetStateService.getRoles();
    const roles = this.aetStateService.getroleState();
    const userRoles = JSON.parse(roles);
   

    if (
      (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
      userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
      userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
      userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
      userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
      userRoles.includes(this.constants.LIOS_UAC_AET_LP) ||
      userRoles.includes(this.constants.LIOS_UAC_General_User)
    ) {
      if (
        (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
        userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
        userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
        userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
        userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
        userRoles.includes(this.constants.LIOS_UAC_AET_LP)
      ) {
        this.isAccessible = true;

      }
    } else {
      this.router.navigate([`/home`]);
    }

  }

  findEventType(id,data, name) {
    for(let i=0;i<data.length;i++){
      if(data[i][name] == id){  // NOSONAR
        return data[i].description;
      }
    }
    return "";
  }

etaFormat(date) {
  if(date) {
    const value = moment(date).format('MM/DD/YYYY HH:mm')
    return value;
  }else {
    return "";
  }

}

findLP(data, id){
  for(let i=0;i<data.length;i++){
    if(data[i].vendorId == id){  // NOSONAR
      return data[i].vendorName;
    }
  }
  return "";
}

findRegionDescription(regionCode, regionList){

  if (!regionCode || !Array.isArray(regionList) || !regionList.length) {
    return "";
  }
  for(let i=0;i<regionList.length;i++){
     if(regionList[i].itemCode == regionCode){  // NOSONAR
       return regionList[i].itemDesc;
     }
   }
   return "";
}

resolveEventRegion(editEvent: any, regionList: any[]): string {
  const dashboardRegion = localStorage.getItem('region') || '';
  const regionCode =
    editEvent?.region ||
    editEvent?.regionCode ||
    editEvent?.region_id ||
    dashboardRegion;
  const mappedRegion = this.findRegionDescription(regionCode, regionList);
  return mappedRegion || regionCode || dashboardRegion || '';
}

  loadEventData() {
    this.successMessage=null;
    this.errorMessage=null;
    let fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    let upn = fgaDetails?.user?.userPrincipalName;
    let roles = fgaDetails?.roles?.map(r => r.displayName);
    let lpCodes = this.getUserAttribute('additionalLpCode')  ?.split(',')  ?.map(code => code.trim()) || [];
      console.log(lpCodes);
    this.ngxUiLoaderService.start(CommonConstant.loader);
    const fromDashboard = this.route.snapshot.pathFromRoot.flatMap((val)=> val.url.join('')).join('/').includes('dashboard');
    const data = {
      eventId: this.eventId,
      pageNo: fromDashboard? '0':'1',
      pageSize: '50'
    };
    this.eventService.getEventDetails(data, upn,roles, lpCodes).subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.eventData = res;
        this.eventType = this.findEventType(this.eventData.editEvent.eventTypeId, this.eventData.eventTypeList, 'eventTypeId');
        this.plannedUnload = this.etaFormat(this.eventData.editEvent.arrival);
  this.eventRegion = this.resolveEventRegion(this.eventData.editEvent, this.eventData.regionList);
        this.eventRoute = this.eventData.editEvent.puRoute;
        this.eventEta = this.etaFormat(this.eventData.editEvent.eta);
        this.problemType = this.findEventType(this.eventData.editEvent.problemTypeId, this.eventData.problemTypes, 'problemTypeId');
        this.eventStatus = this.findEventType(this.eventData.editEvent.statusId,this.eventData.eventStatuses, 'statusId');
        if(this.eventStatus == 'Closed') {  // NOSONAR
          this.reOpen = false;
        } else {
          this.reOpen = true;
        }
        this.logisticProvider = this.findLP(this.eventData.logisticsPartners,this.eventData.editEvent.transportationProviderId);
        if(this.eventData.editEvent.comments !=   null) { // NOSONAR
          this.eventComments = this.eventData.editEvent.comments;
        }
        this.lastUpdated = this.etaFormat(this.eventData.editEvent.lastUpdated);
        this.lastUpdatedBy = this.eventData.editEvent.lastUpdatedBy;
        if (res.orderSize > 0) {
          this.apiCall();

        }
      },
      error: (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
      }
    })
  }

  	  
	  
  getUserAttribute(key: string): any {

    let fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));

    return fgaDetails?.user?.applicationUserAttribute
      ?.flatMap(app => app.userAttributes)
      ?.find(attr => attr.key === key)
      ?.value;
  }	
  
  apiCall() {
    this.successMessage=null;
    this.errorMessage=null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    const data = {
      eventId: this.eventId,
      pageNo: '1',
      pageSize: '1000'
    };
    this.eventService.getEvents(data).subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.displayRowData = res;
        this.rowCount = this.displayRowData.length;
        
      },
      error: (error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
        console.info(error);
      }
    })
  }
  onFilterChanged(params: FilterChangedEvent): void {
    this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
    this.rowCount = params.api?.getDisplayedRowCount();
    const check = document.getElementById('lbTotalPages').innerHTML;
    if(this.rowCount == 0 && Number(check) == 0 ){  // NOSONAR
      document.getElementById('lbCurrentPage').innerHTML='0';
    }
    }
  sizeToFit() { this.gridApi?.sizeColumnsToFit() };

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.applyTransaction({ add: this.displayRowData }); 
    
  }

  onUpdateEvent(_event) {
    this.loadEventData();
  }

  goToNexpage() { this.gridApi.paginationGoToNextPage() }
  goToPreviousPage() { return this.gridApi.paginationGoToPreviousPage() }
  goToFirstPage() { this.gridApi.paginationGoToFirstPage() }
  goToLastPage() { return this.gridApi.paginationGoToLastPage()  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false;
      
    }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onPaginationChanged() {
    if (this.gridApi) {
      this.setText('#lbCurrentPage', this.gridApi.paginationGetCurrentPage() + 1);
      this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") {  // NOSONAR
      this.paginationPageSize = event.target.value;
      
    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }
  setText(selector: string, text: any) {
    if (this.rowCount > 0) {
      (document.querySelector(selector) as any).innerHTML = text;
    }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }

}


